export default __webpack_public_path__ + "static/media/hayat2.b454fff3.mp4";